<template>
	<section class="small-12 columns unitMix" v-if="property">
		<div class="small-12 widget">
			<div class="small-12 widgetTitle flex vertical-align">
				<h2 class="small-12 flex vertical-align"> 
					Unit Mix
				</h2>
			</div>
			<div class="small-12 chartContainer">
				<div class="small-12 columns chart chart-line-s" style="margin-top:10px;" v-if="chartData && chartOptions">
					<div class="small-12 wrap">
						<pie-chart :chartOptions="chartOptions" :chartData="chartData"></pie-chart>
					</div>
				</div>
			</div>
			<div class="small-12 unitBreakdown">
				<div class="small-12 table">
					<div class="small-12 tableHeader">
						<ul class="small-12 flex tableRow">
							<li class="tableCell small-4">
								<p class="small-12 text-overflow">Type</p>
							</li>
							<li class="tableCell small-3">
								<p class="small-12 text-overflow flex justify-right">Units</p>
							</li>
							<li class="tableCell small-5">
								<p class="small-12 text-overflow flex justify-right">Rent/Mo.</p>
							</li>
						</ul>
					</div>
					<div class="small-12 tableBody" v-if="property.metrics.units.breakdown.length > 0">
						<ul class="small-12 flex tableRow" style="margin-bottom:0;" v-for="(type, index) in property.metrics.units.breakdown" :key="index">
							<li class="tableCell small-4">
								<p class="small-12 text-overflow flex vertical-align cDark">
									<b class="small-12 text-overflow">{{type.title}}</b>
								</p>
							</li>
							<li class="tableCell small-3">
								<p class="small-12 text-overflow flex vertical-align justify-right">
									{{type.count}}
								</p>
							</li>
							<li class="tableCell small-5">
								<p class="small-12 text-overflow flex vertical-align justify-right">
									${{ type.actual_rent | noDecimals }}
								</p>
							</li>
						</ul>
					</div>
					<div class="small-12 tableBody" v-else>
						<ul class="small-12 flex tableRow" style="margin-bottom:0;">
							<li class="tableCell small-4">
								<p class="small-12 text-overflow flex vertical-align cDark">
									<b class="small-12 text-overflow">--</b>
								</p>
							</li>
							<li class="tableCell small-3">
								<p class="small-12 text-overflow flex vertical-align justify-right">
									--
								</p>
							</li>
							<li class="tableCell small-5">
								<p class="small-12 text-overflow flex vertical-align justify-right">
									--
								</p>
							</li>
						</ul>
					</div>
					<div class="small-12 tableFooter border-top">
						<ul class="small-12 flex tableRow">
							<li class="tableCell small-6">
								<p class="small-12 text-overflow">Total</p>
							</li>
							<li class="tableCell small-6">
								<p class="small-12 text-overflow flex justify-right">${{totalActualRent | noDecimals}}</p>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>

	// Import firebase
	import { firebaseAuth, usersModel } from '@/firebase/firebase-config'

	// Import the mixins
	import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
	import { AbbreviateNumbersFilters } from '@/mixins/filters/AbbreviateNumbersFilters'

	// Import the components
	import PieChart from '@/components/framework/charts/PieChart.vue'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'UnitMix',

		/*
		**  Register the components
		*/

		components: {

			PieChart

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			AbbreviateNumbersFilters

		],

		/*
		**  Set the props
		*/

		props: {

			property: {
				type: Object,
				default: () => null
			}

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			future_item: false,
			chartData: null,
			chartOptions: null,
			chartLabels: [],
			chartSeries: []

		}),

		/*
		**  Watch em'
		*/

		watch: {

			property: {

				immediate: true, // Load on created
				handler(property) {

					if (property && property.metrics.units.breakdown.length > 0) {

						// Populate chart series
						this.populateChart();

					} else {

						// Set an empty chart
						this.setEmptyChart();

					}

				}

			}

		},

		/*
        ** Do this first
        */

        mounted() {

        	// Set the options
			this.populateChartOptions();

        },

        /*
		**  Set up the methods
		*/

		methods: {

			populateChartOptions: function() {

				// Populate the options
				this.chartOptions = {
					responsive: true, 
					maintainAspectRatio: false,
					legend: {
						display: false,
						position: 'right'
					},
					tooltips: {
				      enabled: true,
				    },
				    cutoutPercentage: 60
				}

			},

			setEmptyChart: function() {

				// Set the series data
				this.chartSeries.push([0, 0, 0]);

				// Populate the chart data
				this.chartData = {

					labels: ['No Data', '2 beds 1 bath', '3 beds 2 baths'],
					datasets: [
						{
							backgroundColor: ['#f4f5f8', '#3d2f9e', '#725ad0'],
							borderColor: '#ffffff',
							hoverBorderWidth: 0,
							data: [100, 0, 0]
						}
					]

				}
			},

			populateChart: function() {

				// Set the series data
				this.property.metrics.units.breakdown.forEach(unit_type => {

					// Calculate percentage
					let percentage = ((unit_type.count / this.property.metrics.units.total) * 100).toFixed(0);

					// Add to series
					this.chartSeries.push(percentage);

					// Set the chart labels
					this.chartLabels.push(unit_type.title);

				});

				// Populate the chart data
				this.chartData = {

					labels: this.chartLabels,
					datasets: [
						{
							backgroundColor: ['#18bbf7', '#3d2f9e', '#725ad0'],
							data: this.chartSeries,
							borderColor: '#ffffff',
							hoverBorderWidth: 0,
						}
					]

				}

			}

		},

		 /*
		**  Set the computed props
		*/

		computed: {

			totalActualRent: function() {

				let totalRent = 0;

				this.property.metrics.units.breakdown.forEach(unit_type => {

					totalRent = totalRent + unit_type.actual_rent;

				});

				return totalRent;

			}

		}

	}

</script>